module.exports = __webpack_public_path__ + "img/authy.1da0492e.svg";